import classNames from "classnames";
import { useState } from "react";
import type { BorderRadius, TextAlignment } from "schemas";
import { IconButton, bgStyles, borderStyles, flexStyles, iconStyles, paddingStyles, positionStyles } from "ui";
import { Editor } from "./Editor";
import { InlineButton } from "./InlineButton";

export type ButtonBlockType = "Link" | "Phone" | "Email";

interface Props {
  contentRef: (node: HTMLElement | null) => void;
  buttonType: ButtonBlockType;
  url: string;
  phone: string;
  email: string;
  buttonTextColor: string;
  buttonBackgroundColor: string;
  buttonTextAlignment: TextAlignment;
  buttonBorderRadius: BorderRadius;
  updateBlock: (props: Partial<{ buttonType: string; url: string; email: string; phone: string }>) => void;
  blockId: string;
}

export function ButtonBlock({
  contentRef,
  buttonType,
  updateBlock,
  url,
  phone,
  email,
  buttonTextColor,
  buttonBackgroundColor,
  buttonTextAlignment,
  buttonBorderRadius,
}: Props) {
  const [editing, setEditing] = useState(!email && !phone && !url);
  const onChangeButtonType = (type: ButtonBlockType) => {
    updateBlock({ buttonType: type });
  };
  const onChangeUrl = (value: string) => {
    updateBlock({ url: value });
  };
  const onChangePhone = (value: string) => {
    updateBlock({ phone: value });
  };
  const onChangeEmail = (value: string) => {
    updateBlock({ email: value });
  };

  return (
    <>
      <InlineButton
        buttonType={buttonType}
        contentRef={contentRef}
        email={email}
        url={url}
        phone={phone}
        extra={
          <>
            <div
              className={classNames(
                positionStyles.absolute,
                positionStyles.right050,
                positionStyles.top050,
                flexStyles.horiz050,
              )}
            >
              <IconButton
                className={classNames(
                  bgStyles.neutral0,
                  borderStyles.neutral200,
                  positionStyles.zIndex5,
                  paddingStyles.p075,
                  iconStyles.neutral600,
                )}
                square
                iconType="Edit"
                onClick={() => setEditing(!editing)}
              />
            </div>
            {editing && (
              <Editor
                onChangeButtonType={onChangeButtonType}
                onChangeUrl={onChangeUrl}
                onChangePhone={onChangePhone}
                onChangeEmail={onChangeEmail}
                buttonType={buttonType}
                url={url}
                phone={phone}
                email={email}
              />
            )}
          </>
        }
        buttonTextColor={buttonTextColor}
        buttonBackgroundColor={buttonBackgroundColor}
        buttonTextAlignment={buttonTextAlignment}
        buttonBorderRadius={buttonBorderRadius}
      />
    </>
  );
}
